import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';

export const ToggleButtonGroup = ({ ...props }: MuiToggleButtonGroupProps) => {
  return <MuiToggleButtonGroup {...props} />;
};
